import $ from 'jquery';
import _ from 'underscore';
import Backbone from "backbone";
import SequencerOperationLog from "models/audioEditor/sequencerOperationLog/SequencerOperationLog";
import RSVP from "rsvp";

const SequencerOperationChangeSpeakerForParagraphOperationLog =  SequencerOperationLog.extend({
    idAttribute: "id",


    constructor: function(attributes, options) {
        SequencerOperationLog.apply(this, [attributes, options]);
        
    },

    getOperationName : function(){
        return "Change Speaker Paragraph";
    },
    
    setSequencerNodeCidArray : function(sequencerNodeCidArray){
        this.set("sequencerNodeCidArray", sequencerNodeCidArray);
    },

    getSequencerNodeCidArray : function(){
        return this.get("sequencerNodeCidArray");
    },

    setSequencerNodeCidToOldSpeakerId : function(sequencerNodeCidToOldSpeakerId){
        this.set("sequencerNodeCidToOldSpeakerId", sequencerNodeCidToOldSpeakerId);
    },

    getSequencerNodeCidToOldSpeakerId : function(){
        return this.get("sequencerNodeCidToOldSpeakerId");
    },

    setNewSpeakerInfo : function(newSpeakerInfo){
        this.set("newSpeakerInfo", newSpeakerInfo);
        this.set("newSpeakerId", newSpeakerInfo ? newSpeakerInfo.getSpeakerId() : null);
    },

    getNewSpeakerInfo : function(){
        return this.get("newSpeakerInfo");
    },

    getNewSpeakerId : function(){
        const storedSpeakerId = this.get("newSpeakerId");
        if(storedSpeakerId){
            return storedSpeakerId;
        }
        const legacySpeakerInfo = this.get("newSpeakerInfo");
        return legacySpeakerInfo ? legacySpeakerInfo.getSpeakerId() : null;
    },


});

export default SequencerOperationChangeSpeakerForParagraphOperationLog;
